import React from 'react';
import { MonthlyPrice } from '../listing-tile.style';
import Icon from '../../icon/icon';

const CarMonthlyPrice = ({
    price,
    setOpenHPModal,
}: {
    price: string;
    setOpenHPModal?: (open: boolean) => void;
}) => {
    // Cases are treated as £0 deposit, credit score is "Excellent", and 60 months repayment term
    const borrowAmount = parseFloat(price.replace(/[^0-9.]/g, ''));
    const repayMonths = 60;
    const smallAmountLoanRates: number = 12.9 / 100;
    const largeAmountLoanRates: number = 8.9 / 100;

    const computeLowerRValue = (interestRateDecimal: number) =>
        -1 + (1 + interestRateDecimal) ** (1 / 12);

    const computeCapitalRValue = (lowercaseRValue: number, repayMonths: number) =>
        (1 + lowercaseRValue) ** repayMonths;

    const getInterestDecimal = () =>
        borrowAmount < 16000 ? smallAmountLoanRates : largeAmountLoanRates;

    const computeMonthlyCost = () => {
        const r = computeLowerRValue(getInterestDecimal());
        const R = computeCapitalRValue(r, repayMonths);

        return Math.ceil(borrowAmount * R * r * (1 / (R - 1)));
    };

    const monthlyCost = borrowAmount <= 0 ? 0 : computeMonthlyCost();

    return (
        <MonthlyPrice>
            <span>Finance from £{monthlyCost} pm</span>
            <Icon
                type="info-outline"
                color="grey"
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setOpenHPModal && setOpenHPModal(true);
                }}
            />
        </MonthlyPrice>
    );
};

export default CarMonthlyPrice;
